import React, { memo } from 'react';

const ContactsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M16 0c-8.832 0-16 7.168-16 16s7.168 16 16 16c8.832 0 16-7.168 16-16s-7.168-16-16-16zM16 4.8c2.656 0 4.8 2.144 4.8 4.8s-2.144 4.8-4.8 4.8c-2.656 0-4.8-2.144-4.8-4.8s2.144-4.8 4.8-4.8zM16 27.52c-4 0-7.536-2.048-9.6-5.152 0.048-3.184 6.4-4.928 9.6-4.928 3.184 0 9.552 1.744 9.6 4.928-2.064 3.104-5.6 5.152-9.6 5.152z"
        />
    </svg>
);

export default memo(ContactsIcon);
